import React, { Component, useState, useRef } from "react";
import { connect } from 'react-redux';
import { MapContainer, TileLayer, WMSTileLayer, LayersControl, useMap } from 'react-leaflet'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import CustomWMSLayer from "./ClickInfo";
import Api_tnn from "../../../api/api.tnn";
import message from "../../../components/Messages";
import typo, { MESSAGE } from "../../../constants/dictionaries";
import TTCT_XT from "./ThongTinChiTiet/TTCT_XT";
import TTCT_NM from "./ThongTinChiTiet/TTCT_NM";
import { Modal } from "antd"
import ControllerSearch from "./TimKiem/CustomSearch"
import ControllerButton_Custom from "./GroupButton"
import ChuThich_Custom from "./ChuThich"
import BanDoVietNam from "./BanDoVN"
import constants from "../../../constants/constant"
import 'leaflet-measure'
import Api_spatial from "../../../api/api.spatial";
import { APP_GEO_URI } from "../../../config"
import Api_quantrac from "../../../api/api.quantrac";
import InfoTramQTModal from "./Modal/routerTramInfo"
let check = 0
const TraCuuTNN = ({ user }) => {
  const center = [16.371824, 107.549195]
  const URL = APP_GEO_URI
  const [openModalMauQT, setopenModalMauQT] = useState(false);
  const [data_modal_mau, setdata_modal_mau] = useState({
    idGiayPhep: null,
    idTramQT: null,
    loai: null,
    kyHieu: null
  });
  const [displayTab, setdisplayTab] = useState("none");
  const [displayToaDo, setdisplayToaDo] = useState("none");
  const [idcongtrinh, setidcongtrinh] = useState(null);
  const [loaicongtrinh, setloaicongtrinh] = useState(null);

  function showData(data) {
    if (data) {
      setdata_modal_mau({
        idGiayPhep: data.thongtinchung_id,
        idTramQT: data.idtramquantrac,
        loai: data.id,
        kyHieu: data.kyhieu
      })
      setopenModalMauQT(true)
    }
  }
  function dulieu_congtrinh(idcongtrinh, loaicongtrinh) {
    setidcongtrinh(idcongtrinh)
    setloaicongtrinh(loaicongtrinh)
  }
  function hideTab() {
    if (displayTab === "none") {
      setdisplayTab("block")
    } else {
      setdisplayTab("none")
    }
  }
  function hideToaDo() {
    if (displayToaDo === "block") {
      setdisplayToaDo("none")
    } else {
      setdisplayToaDo("block")
    }
  }
  function handleCancel() {
    setopenModalMauQT(null)
  }
  function Location_Tinh() {
    const map = useMap();
    if (check === 0) {
      if (Number(constants.CAP_TRIEN_KHAI) === 2) {
        new Api_spatial()
          .GetSpatialTinhs({
            token: user.access_token,
            tentinh: constants.TEN_DVHC
          })
          .then((res) => {
            if (res && res.result) {
              let toado = res.result.slice(6, -1).split(" ")
              map.flyTo([Number(toado[1]), Number(toado[0])], 10);
              check += 1
            }
          })
          .catch((err) => {
            message.error(err.message);
          });
      }
      return null
    } else {
      return null
    }
  }
  return (
    <div>
      <MapContainer center={center} zoom={6} style={{ height: window.innerHeight - 42 }} className="control_layers">
        <Location_Tinh />
        <ControllerSearch user={user}
          displayTab={displayTab}
          hideTab={() => hideTab()}
          dulieu_congtrinh={(idcongtrinh, loaicongtrinh) => { dulieu_congtrinh(idcongtrinh, loaicongtrinh) }}
        />
        <ControllerButton_Custom user={user} displayToaDo={displayToaDo} hideToaDo={() => hideToaDo()} />
        <ChuThich_Custom />
        <LayersControl position="topright">
          <BanDoVietNam opacity={1} />
          <LayersControl.Overlay name="Google map vệ tinh (Tham khảo)">
            <ReactLeafletGoogleLayer apiKey={constants.KEY_GG_DP} type={'satellite'} zIndex='3' />
          </LayersControl.Overlay>
          <LayersControl.Overlay name="Google map đường phố (Tham khảo)">
            <ReactLeafletGoogleLayer apiKey={constants.KEY_GG_DP} type={'hybrid'} zIndex='4' />
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Lớp công trình">
            < WMSTileLayer
              layers={"cscore.spatial" + constants.GEO_WMS + ":qt_diem"}
              params={{
                transparent: true,
                format: 'image/png',
              }}
              url={URL}
            />
          </LayersControl.Overlay >
          <CustomWMSLayer
            url={URL}
            showData={(data, url) => showData(data, url)}
            layer={["cscore.spatial" + constants.GEO_WMS + ":qt_diem"]}
            user={user}
          />
        </LayersControl>
      </MapContainer >

      <div>
        {openModalMauQT &&
          <Modal
            title={typo.cscore_info_tram_qt}
            centered
            closable={true}
            visible={openModalMauQT}
            width="80%"
            footer={null}
            onCancel={handleCancel}
            maskClosable={false}
          >
            <InfoTramQTModal
              handleCloseModal={handleCancel}
              user={user}
              data_modal_mau={data_modal_mau}
            />
          </Modal>
        }
      </div>
    </div>
  )
}
export default TraCuuTNN;

